import Vue from "vue";
import vueFilterPrettyBytes from "vue-filter-pretty-bytes";

Vue.use(vueFilterPrettyBytes);
